import { Scroll, Preload, ScrollControls } from '@react-three/drei'
import '../styles.css'

export default function Blog() {
    return (            
    <div className="article-row">
        <div className="article-card">
            <a className={"article-title"} href="/articles/sift">
                {/* DEMYSTIFYING SCALE-INVARIANT FEATURE TRANSFORM */}
                Demystifying Scale-Invariant Feature Transform
                {/* New Graphic Design */}
            </a>
            {/* <hr className="article-hr"/> */}
            <h5>
                A gentle introduction to feature detection with Scale-Invariant Feature Transform (SIFT) - the gold standard in terms of robustness
                {/* An overview */}
            </h5>
            {/* <div className="fakeimg" >Image</div> */}
        </div>
        <div className="article-card">
            <a className={"article-title"} href="/articles/ibvs">
                {/* DEMYSTIFYING SCALE-INVARIANT FEATURE TRANSFORM */}
                Understanding Image-Based Visual Servo
                {/* New Graphic Design */}
            </a>
            {/* <hr className="article-hr"/> */}
            <h5>
                A gentle introduction to Image-Based Visual Servo -  a robust vision-based robot controller
                {/* An overview */}
            </h5>
            {/* <div className="fakeimg" >Image</div> */}
        </div>
        {/* <div className="card">
            <h2>TITLE HEADING</h2>
            <h5>Title description</h5>
            <p>Some text..</p>
        </div>
        <div className="card" style={{ marginBottom: '10vh'}}>
            <h2>TITLE HEADING</h2>
            <h5>Title description</h5>
            <div className="fakeimg" >Image</div>
            <p>Some text..</p>
        </div> */}
    </div>
    );
}
